var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('va-create-layout',[_c('reading-competitions-form',{attrs:{"title":_vm.title,"item":_setup.createCompetitionItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }